import { useNavigate } from "react-router-dom";

// api
import { getUser, signout } from "../../services/api/user";


function MyPage() {
    const navigate = useNavigate();

    const handleClickSignOutButton = async () => {
        try{
            const res = await signout();

            localStorage.removeItem("token");
            localStorage.removeItem("name");
            navigate("/sign-in");
        }catch(err){
            console.error(err);
            if(err.response && err.response.status===401){
                localStorage.removeItem("token");
                localStorage.removeItem("name");
                navigate("/sign-in");
            }
        }
    }

    const executeGLMP = async () => {
        try{
            let userInfo = await getUser();
            if (userInfo.status === 200) {
                let href =
                process.env.REACT_APP_LAUNCHER_URL_PREFIX +
                ".metaverse://token=" +
                localStorage.getItem("token");
                window.location.href = href;
            } else {
                localStorage.removeItem("token");
                localStorage.removeItem("name");
                navigate("/sign-in");
                alert("Your login has expired. Please sign in again");
            }
        }catch(err){
            console.error(err);
            localStorage.removeItem('token');
            localStorage.removeItem('name');
            navigate('/sign-in');
        }        
    }

    const executeGLMPToWeb = async () => {
        try{
            let userInfo = await getUser();
            if (userInfo.status === 200) {
                let sessionParams = btoa("-token "+localStorage.getItem("token"));
                let href =
                process.env.REACT_APP_GLMP_WEB_BASEURL +
                "?s=" + sessionParams;
                window.location.href = href;
            } else {
                localStorage.removeItem("token");
                localStorage.removeItem("name");
                navigate("/sign-in");
                alert("Your login has expired. Please sign in again");
            }
        }catch(err){
            console.error(err);
            localStorage.removeItem('token');
            localStorage.removeItem('name');
            navigate('/sign-in');
        }        
    }

    return (
        <div className="MyPage">
            <div className="Titie">
                <div>Welcome!</div>
                <div>Welcome to GLMP.</div>
            </div>
            <div className="Description">
                Good to see you. Welcome to GLMP. You are already signed in.
            </div>
            <button
                className="ExecuteButton"
                onClick={executeGLMP}
            >
                Open GLMP
            </button>
            <button
                className="ExecuteButtonToWeb"
                onClick={executeGLMPToWeb}
            >
                Open GLMP (Web)
            </button>
            <button
                className="SignOutButton"
                onClick={handleClickSignOutButton}
            >
                Sign out
            </button>
        </div>
    );
}

export default MyPage;